<template>
  <div class="ArticleList" v-title data-title="文章列表">
    <div class="pt5 pl5 text-left">
      <van-button size="small" class="btn-common" plain="" type="info" @click="back">返回</van-button>
    </div>

    <div class="row align-items-center">
      <div class="row align-items-center pt2">
        <div class="pl9 pr1">关键字</div>
        <input class="keywords-input" v-model="params.keywords" placeholder="请输入关键字"/>
      </div>
      <div class="row align-items-center pt2">
        <div class="pl10 pr1">状态</div>
        <select placeholder="请选择状态" v-model="params.status">
          <option v-for="option in statusOptions" :key="option.value" :value="option.value">
          {{option.text}}
        </option>
        </select>
      </div>
      <div class="row align-items-center pt2">
        <div class="pl4 pr1">文章类型</div>
        <select placeholder="请选择文章类型" v-model="params.type">
          <option v-for="option in typeOptions" :key="option.value" :value="option.value">
          {{option.text}}
        </option>
        </select>
      </div>
      <div class="flex-1 pl7"></div>
      <div class="pt2 pl2 pr5">
        <van-button type="info" size="small" class="button"
                @click="getData()">查 询</van-button>
      </div>
      <div class="pt2 pl2 pr5">
        <van-button size="small" class="button" plain type="info" @click="addItem()">新增</van-button>
      </div>
    </div>
    <div class="row align-items-center pr7 pt5 pl3">
      <div class="font-bold flex-1 text-left">共{{(total||0)}}篇</div>
    </div>
    <van-list
      v-model="loading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      :finished-text="records.length > 10 ? '没有更多了' :''"
      @load="loadMore"
    >
      <div
        v-for="(item) in records"
        :key="item.id"
        @click="clickItem(item)"
      >
        <ArticleItem :item="item">
          <div v-if="(editId === item.id)" title="点击蒙层关闭操作区" class="article-action row align-items-center justify-content-center">
            <van-button type="danger" plain title="删除" @click.stop="deleteItem(item)">删除</van-button>
            <div class="pl5"></div>
            <van-button type="info" plain title="详情" @click.stop="viewItem(item)">详情</van-button>
            <div class="pl5"></div>
            <van-button type="warning" plain title="编辑" @click.stop="editItem(item)">编辑</van-button>
            <!-- <van-button type="info" plain @click="changeItem(item)">修改类型</van-button> -->
            <div @click.stop="copyLink(item)" class="col-24 fc-primary mp-link row align-items-center">小程序链接：<textarea class="flex-1" :id="`copy_${item.id}`" v-model="item.mpLink"></textarea></div>
          </div>
        </ArticleItem>
      </div>
    </van-list>

    <van-popup v-model="addShow">
      <div class="font-bold text-center padding7">新增文章</div>
      <div class="row align-items-center pl10 pr10 pb5">
        <div class=" pr5">新增文章的类型</div>
        <select placeholder="请选择新增文章的类型" v-model="addType">
          <option v-for="option in typeOptions" :key="option.value" :value="option.value">
          {{option.text}}
        </option>
        </select>
      </div>
      <div class="pl5 pr5 pb7 row justify-content-center">
        <van-button type="info" plain size="small" @click.stop="addShow = false">取消</van-button>
        <div class="pl7"></div>
        <van-button type="info" size="small" @click.stop="editItem({type: addType})">确定</van-button>
      </div>
    </van-popup>

  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, getArticleList, getArticleDicts, deleteArticle,
} from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';
import ArticleItem from './components/ArticleItem.vue';
import config from '../../config';

const statusName = {
  1: '已发布',
  0: '未发布',
};
export default Vue.extend({
  name: 'ArticleList',
  components: {
    ArticleItem,
  },
  data() {
    const statusOptions = Object.entries(statusName).map(([value, text]) => ({
      value,
      text,
    }));
    statusOptions.unshift({ value: '', text: '全部' });
    return {
      DOWNLOAD_DOMAIN: config.DOWNLOAD_DOMAIN,
      statusOptions,
      typeOptions: [],
      typeMapping: {},
      loading: false,
      actionloading: false,
      error: false,
      finished: false,
      size: 20,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],

      params: {
        keywords: '',
        status: '',
        type: '',
      },
      editId: '',
      addShow: false,
      addType: '',
    };
  },
  methods: {
    copyLink(item) {
      const textarea = document.getElementById(`copy_${item.id}`);
      textarea.select();
      document.execCommand('copy');
      this.$dialog.alert({
        message: '内容已复制到剪切板',
      });
    },
    addItem() {
      this.addShow = true;
      this.addType = '';
    },
    clickItem(item) {
      if (this.editId === item.id) {
        this.editId = '';
        return;
      }
      this.editId = item.id;
    },
    viewItem(item) {
      const path = `/article/detail/${item.id || ''}`;
      // console.log(path);
      this.$router.push(path);
    },
    editItem(item = {}) {
      if (!item.id && !item.type) {
        this.$dialog.alert({
          message: '请先选择文章类型',
        });
        return;
      }
      const path = `/article/edit/${item.id || ''}?type=${item.type}&typeName=${item.typeName || ''}`;
      // console.log(path);
      this.$router.push(path);
    },
    changeItem(item) {

    },
    deleteItem(item) {
      this.actionloading = true;
      this.$dialog.confirm({
        title: '确定',
        message: '删除后无法找回，确定删除吗？',
      }).then(() => {
        sendRequest({
          ...deleteArticle,
          url: `${deleteArticle.url}/${item.id}`,
        }).then((res) => {
          this.getData();
          this.$dialog.alert({
            message: '操作成功',
          });
        }).catch((e) => {
          console.log(e);
          this.$dialog.alert({
            message: `${e.message}`,
          });
        }).then(() => {
          this.$nextTick(() => {
            this.actionloading = false;
          });
        });
      });
    },
    saveItem() {

    },
    getArticleDicts() {
      sendRequest(getArticleDicts).then((res) => {
        const { type = [] } = res || {};
        const typeOptions = type || [];
        const colors = ['#2b85e4', '#dd6161', '#f29100', '#18b566', '#909399'];

        const mapping = {};
        typeOptions.forEach((item, index) => {
          mapping[item.value] = {
            ...item,
            color: colors[index] || '#909399',
          };
        });
        this.typeMapping = mapping;
        typeOptions.unshift({ value: '', text: '全部' });
        this.typeOptions = typeOptions;
      }).catch((e) => {
        console.log(e);
      });
    },
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getData(this.current + 1);
    },
    getData(page = 1) {
      storage.local.remove('article_info');
      this.editId = '';
      // console.log(this.loading);
      this.error = false;
      sendRequest(getArticleList, {
        current: page,
        size: this.size,
        ...this.params,
      }).then((res) => {
        const {
          total = 1, records: datas = [], pages = 1, hasNext = false,
        } = res;
        const records = datas.map(item => ({
          ...item,
          mpLink: `${this.DOWNLOAD_DOMAIN}/article/mp/${item.type || ''}/${item.id || ''}`,
        }));
        // eslint-disable-next-line eqeqeq
        if (page == 1) {
          this.records = records || [];
        } else {
          this.records = this.records.concat(records || []);
        }
        this.total = total;
        this.pages = pages;
        this.hasNext = hasNext;
        this.current = page;
        if (!this.hasNext || (records || []).length < this.size || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    back() {
      // this.$router.back();
      this.$router.push('/home');
    },
  },
  created() {
    this.getArticleDicts();
  },
});
</script>
<style scoped>
  .ArticleList {
    min-height: 100vh;
    /* background-color: #ffffff; */
    font-size: 14px;
  }
  input, select {
    height: 26px;
    width: 120px;
    font-size: 14px;
    border: 1px solid #a7a9af;
    background-color: #ffffff;
    min-width: 100px;
    border-radius: 4px;
  }
  .keywords-input {
    width: 120px;
  }
  .date-select {
    width: 90px;
  }
  .button {
    min-width: 80px;
    height: 26px;
  }

  .article-action {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .mp-link {
    /* color: red; */
    font-weight: bold;
    padding: 0 15px;
  }
</style>
